<template>
<!-- 日志组件 -->
  <el-dialog title="日志" :visible.sync="dialog" @close="closeDialog" :close-on-click-modal="false" width="800px" center>
    <el-form :inline="true" ref="RZform"  :model="RZform" :rules="rules"
     class="demo-form-inline jiaoyan" label-width="90px" size="mini">
   <div>
        <div class="QDtiem" v-if="RZList.length==0">
            <el-button type="primary" v-if="rowData.shipStatus!=1301" @click="addFn(null)">添加日志</el-button>
        </div>
        <div class="guiji">
           <el-timeline >
            <el-timeline-item
              v-for="(item, index) in RZList"
              :key="index"
               :color="item.shipStatus==1103?'red':'#409EFF'"
               >
              <div>
                 <span>【 {{statusFormat(item.shipStatus)}}】</span>
                 <span v-if="rowData.shipStatus!=1301">
                    <i @click="editFn(item)" class="el-icon-edit"> </i>
                    <i @click="delFn(item)" class="el-icon-delete"></i>
                    <i @click="addFn(item)" class="el-icon-plus"></i>
                 </span>
              </div>
              <div style="margin:10px 0">
                <span>{{item.statusTime|dateFormat}}</span>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;{{item.receivingAddressName}}</span>
              </div>
              <div>{{item.remark}}</div>
              <div class="imgBox">
                <el-image
                  v-for="(item1,index1) in item.files" :src="item1.fileUrlOSS" :key="index1"
                  style="width: 290px; height: 200px ; margin-right: 30px;"
                  :preview-src-list="getSrcList(index1,item.files)">
                </el-image>
            </div>
            </el-timeline-item>
          </el-timeline>
        </div>
        <el-dialog append-to-body :title="title" :visible.sync="addMark"  @close="closeDialog1" :close-on-click-modal="false" width="500px" center>
           <div class="inpBox">
              <el-form-item label="船运状态 :" prop="shipStatus">
                <el-select v-model="RZform.shipStatus" placeholder="请选择" @change="change" >
                  <el-option v-for="val in status" :label="val.name" :value="val.id" :key="val.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="timeName" prop="statusTime" v-if="RZform.shipStatus" >
                    <el-date-picker
                      v-model="RZform.statusTime"
                      value-format="timestamp"
                      type="datetime"
                        placeholder="选择日期时间"
                    ></el-date-picker>
              </el-form-item>
              <el-form-item label="港口:" prop="receivingAddressId" class="jiage"
              v-if="RZform.shipStatus==1103||RZform.shipStatus==1101||RZform.shipStatus==1102||RZform.shipStatus==1104">
              <el-select v-model="RZform.receivingAddressId" placeholder="请选择" >
                <el-option v-for="(item) in MTlist" :label="item.addressName" :value="item.addressId" :key="item.addressId"></el-option>
              </el-select>
            </el-form-item>
              <el-form-item label="备注:"  prop="remark" >
                <el-input  placeholder=""   maxlength="500" v-model="RZform.remark"></el-input>
              </el-form-item>
              <div class="addressBox" v-if="RZform.shipStatus==1105||RZform.shipStatus==1106">
                <h4 class="title">
                  <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>凭证</span>
                </h4>
                <div>
                    <div class="imgBox">
                      <uploadImgs :imgList.sync='imgList' :max=5 @remove='remove'></uploadImgs>
                   </div>
                </div>
              </div>
           </div>
         <span slot="footer" class="dialog-footer">
          <el-button @click="addMark=false">取消</el-button>
          <el-button type="primary" @click="addSave('RZform')">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="dialog = false">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { sShipRecordList, shipBerthingAddress, addShipRecord, sShipRecordDelete } from '@/api/shipping'
import uploadImgs from '@/components/uploadImgs.vue'
import { compressImages } from '@/utils/compressImages'
export default {
  name: 'D',
  components: {
    uploadImgs
  },
  props: {
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      dialog: false,
      addMark: false,
      RZform: {},
      RZList: [],
      title: '添加',
      isAdd: true,
      MTlist: [],
      imgList: [],
      status: [
        { name: '请选择', id: '' },
        // { name: '未开始', id: 1001 },
        { name: '已抵锚', id: 1101 },
        { name: '已起锚', id: 1102 },
        { name: '已靠泊', id: 1103 },
        { name: '已离泊', id: 1104 },
        { name: '已封航', id: 1105 },
        { name: '已解封', id: 1106 },
        { name: '装船完成', id: 1201 },
        { name: '卸船完成', id: 1202 },
        { name: '已完成', id: 1301 }
      ],
      rules: {
        shipStatus: [
          { required: true, message: '请选择船运状态', trigger: 'blur' }
        ],
        statusTime: [
          { required: true, message: '请选择时间', trigger: 'blur' }
        ],
        receivingAddressId: [
          { required: true, message: '请选择靠泊港口', trigger: 'blur' }
        ]
      }

    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    this.dialog = true
    this.RZform.shipDateId = this.rowData.id
    sShipRecordList({ shipDateId: this.rowData.id }).then(res => {
      this.RZList = res
      if (res.length > 0) {
        this.rowData.shipStatus = res[res.length - 1].shipStatus
      }
    })
    shipBerthingAddress({ id: this.rowData.id }).then(res => {
      this.MTlist = res
    })
  },
  computed: {
    timeName () {
      let str = ''
      if (this.RZform.shipStatus == 1101) { // 已抵锚
        str = '抵锚时间'
      }
      if (this.RZform.shipStatus == 1102) { // 已起锚
        str = '起锚时间'
      }
      if (this.RZform.shipStatus == 1103) { // 已靠泊
        str = '靠泊时间'
      }
      if (this.RZform.shipStatus == 1104) { // 已离泊
        str = '离泊时间'
      }
      if (this.RZform.shipStatus == 1105) { // 已封航
        str = '封航时间'
      }
      if (this.RZform.shipStatus == 1106) { // 已解封
        str = '解封时间'
      }
      if (this.RZform.shipStatus == 1201) { // 装船完成
        str = '完成时间'
      }
      if (this.RZform.shipStatus == 1202) { // 卸船完成
        str = '完成时间'
      }
      if (this.RZform.shipStatus == 1301) { // 已完成
        str = '完成时间'
      }
      return str
    }
    // statuList () {
    //   let arr = []
    //   if (this.rowData.shipStatus == 1001) { // 未开始
    //     arr = [
    //       { name: '已抵锚', id: 1101 },
    //       { name: '已靠泊', id: 1103 }
    //     ]
    //   }
    //   if (this.rowData.shipStatus == 1101) { // 已抵锚
    //     arr = [
    //       { name: '已起锚', id: 1102 },
    //       { name: '已封航', id: 1105 }
    //     ]
    //   }
    //   if (this.rowData.shipStatus == 1102) { // 已起锚
    //     arr = [
    //       { name: '已抵锚', id: 1101 },
    //       { name: '已封航', id: 1105 },
    //       { name: '已靠泊', id: 1103 }
    //     ]
    //   }
    //   if (this.rowData.shipStatus == 1103) { // 已靠泊
    //     arr = [
    //       { name: '装船完成', id: 1201 },
    //       { name: '卸船完成', id: 1202 }
    //     ]
    //   }
    //   if (this.rowData.shipStatus == 1104) { // 已离泊
    //     arr = [
    //       { name: '已抵锚', id: 1101 },
    //       { name: '已封航', id: 1105 },
    //       { name: '已靠泊', id: 1103 }
    //     ]
    //   }
    //   if (this.rowData.shipStatus == 1105) { // 已封航
    //     arr = [
    //       { name: '已解封', id: 1106 }
    //     ]
    //   }
    //   if (this.rowData.shipStatus == 1106) { // 已解封
    //     arr = [
    //       { name: '已起锚', id: 1102 },
    //       { name: '已抵锚', id: 1101 },
    //       { name: '已靠泊', id: 1103 }
    //     ]
    //   }
    //   if (this.rowData.shipStatus == 1201) { // 装船完成
    //     arr = [
    //       { name: '已离泊', id: 1104 }
    //     ]
    //   }
    //   if (this.rowData.shipStatus == 1202) { // 1202
    //     arr = [
    //       { name: '已离泊', id: 1104 },
    //       { name: '已完成', id: 1301 }
    //     ]
    //   }
    //   return arr
    // }
  },
  methods: {
    // 船期状态改
    change (e) {
      shipBerthingAddress({ id: this.rowData.id }).then(res => {
        this.MTlist = res
      })
    },
    // 点击凭证放大
    getSrcList (index, arr) {
      let imglist = []
      arr.forEach(item => {
        imglist.push(item.fileUrlOSS)
      })
      return imglist.slice(index).concat(imglist.slice(0, index))
    },
    // 删除图片
    remove (file) {
      this.RZform.delFileIds.push(file.id)
    },
    addFn (item) {
      if (item) {
        this.RZform.sort = item.sort - 0 + 1
      } else {
        this.RZform.sort = 1
      }
      this.addMark = true
      this.isAdd = true
      this.title = '添加'
    },
    editFn (row) {
      this.RZform = JSON.parse(JSON.stringify(row))
      this.$set(this.RZform, 'shipStatus', Number(row.shipStatus))
      if (row.receivingAddressId) {
        this.$set(this.RZform, 'receivingAddressId', row.receivingAddressId)
      }
      row.files.forEach((item, index) => {
        this.$set(this.imgList, index, { status: 'ready', url: item.fileUrlOSS, id: item.id })
      })
      this.RZform.delFileIds = []
      this.isAdd = false
      this.addMark = true
      this.title = '修改'
    },
    addSave () {
      if (this.RZform.shipStatus == 1301) {
        this.$confirm('已完成状态的运单，数据将不可修改，包括导入码单', '系统提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          customClass: 'wanchengtishi'
        }).then(() => {
          this.save1()
        }).catch(() => {

        })
      } else {
        this.save1()
      }
    },
    save1 () {
      this.$refs.RZform.validate((valid) => {
        if (valid) {
          let imgfile = new FormData()
          if (this.RZform.receivingAddressId) {
            this.RZform.receivingAddressName = this.MTlist.find(item1 => item1.addressId == this.RZform.receivingAddressId).addressName
          }
          imgfile.set('params', JSON.stringify(this.RZform))
          let that = this
          let arr = []
          this.imgList.forEach(item => {
            if (!item.id) {
              arr.push(item)
            }
          })
          console.log(arr)
          compressImages(arr, {
            width: 1000
          }).then(result => {
            console.log(result)
            result.forEach(item => {
              imgfile.append('files', item)
            })
            that.jiekou(imgfile)
          })
        }
      })
    },
    jiekou (data) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      addShipRecord(data).then(res => {
        loading.close()
        this.$message({
          message: '添加成功',
          type: 'success'
        })
        this.addMark = false
        this.$parent.getList()
        sShipRecordList({ shipDateId: this.rowData.id }).then(res => {
          this.RZList = res
          this.$set(this.rowData, 'shipStatus', res[res.length - 1].shipStatus)
        })
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 删除
    delFn (row) {
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        sShipRecordDelete({ id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.$parent.getList()
          sShipRecordList({ shipDateId: this.rowData.id }).then(res => {
            this.RZList = res
            this.$set(this.rowData, 'shipStatus', res[res.length - 1].shipStatus)
          })
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    closeDialog () {
      this.$emit('destroy')
    },
    closeDialog1 () {
      this.RZform = {
        shipDateId: this.rowData.id
      }
      this.imgList = []
    },
    // 状态格式化
    statusFormat (cellValue) {
      switch (cellValue) {
        case 1001:
          return '未开始'
        case 1101:
          return '已抵锚'
        case 1102:
          return '已起锚'
        case 1103:
          return '已靠泊'
        case 1104:
          return '已离泊'
        case 1105:
          return '已封航'
        case 1106:
          return '已解封'
        case 1201:
          return '装船完成'
        case 1202:
          return '卸船完成'
        case 1301:
          return '已完成'
      }
    }
  },
  destroyed () {
    this.dialog = false
  }
}
</script>

<style scoped lang='less'>

.guiji{
  width: 100%;
  max-height:500px ;
  border-top:1px dashed #ddd;
  overflow-y: auto;
  padding: 20px 10px;
}
.QDtiem{
 /deep/.el-date-editor .el-input__inner{
   border:none;
   padding: 0;
 }
 /deep/.el-input__icon{
   display: none;
 }
}
/deep/.inpBox .el-input__inner{
  width:180px;
}
/deep/.inpBox .el-form-item{
  display: flex;
  margin-bottom: 16px;
}
/deep/.el-icon-edit,.el-icon-delete,.el-icon-plus{
  margin: 0 8px;
  color: #0B25D6 ;
  font-size: 16px;
}

</style>
<style lang='less'>
.wanchengtishi{
  .el-message-box__header{
       background: #ff9933;
  }
   .el-message-box__title{
      color: #fff;
    }
   .el-message-box__close{
   color: #fff;
  }
  .el-button--primary {
    background-color: #ff9933;
    border-color: #ff9933;
  }
  .el-message-box__status.el-icon-warning{
     color: red;
  }
  .el-message-box__content{
     color: red;
  }
  .el-message-box__btns{
      text-align: center;
  }
}
</style>
